import { apiRequest } from '../api/client';

/**
 * The four session operations the auth context needs. Kept as a plain object
 * (not a class) so tests can inject a fake implementation into `AuthProvider`
 * without mocking the global `fetch` or `apiRequest`.
 */
export const authApi = {
  me: () => apiRequest('/auth/me'),
  login: (email, password) => apiRequest('/auth/login', { method: 'POST', body: { email, password } }),
  logout: () => apiRequest('/auth/logout', { method: 'POST' }),
  changePassword: (currentPassword, newPassword) => apiRequest('/auth/change-password', {
    method: 'POST',
    body: { currentPassword, newPassword },
  }),
};
